type props = {
  title: string;
  description: string;
};

const CustomPageHeader = ({ title, description }: props) => {
  return (
    <div className="flex-col gap-2">
      <p className="text-2xl font-medium text-primary-3 ">{title}</p>
      <p className="text-base text-gray-80 ">{description}</p>
    </div>
  );
};

export default CustomPageHeader;
